import { UploadFile } from "antd";
import React from "react";
import { ApplicantUserNameOnDocumentAsset, FileInfo } from "../../../../generated";
import { FilePreview } from "../../../shared/file-preview/file-preview";
import { AuthResult } from "../../../shared/file-upload/azure-upload";
import { FileUploadButton } from "../../../shared/file-upload/file-upload-button";
 
 
interface ProfileIdentityDocumentUploadProps {
  isProcessing?: boolean;
  nameOnDocumentAssets: ApplicantUserNameOnDocumentAsset[];
  assetUpdateFunction: (file: File) => Promise<AuthResult>;
  onAssetUpdate: (response: any, file: UploadFile) => Promise<void>;
  files: FileInfo[];
}
 
export const ProfileIdentityDocumentUpload: React.FC<ProfileIdentityDocumentUploadProps> = ({
  nameOnDocumentAssets,
  assetUpdateFunction,
  onAssetUpdate,
  files,
  isProcessing,
}) => {
  return (
    <div>
      <div className="flex w-full gap-5 flex-wrap h-auto">
        {nameOnDocumentAssets?.map((doc: ApplicantUserNameOnDocumentAsset) => (
          <FilePreview
            key={doc.id}
            fileUrl={
              files?.find((f) => f.name.includes(doc.documentName?.replace(/\s+/g, "-") ?? ""))
          ?.url ?? ""
            }
            fileName={doc.documentName?.replace(/\s+/g, "") ?? ""}
            fileType={
              files?.find((f) => f.name.includes(doc.documentName?.replace(/\s+/g, "-") ?? ""))
          ?.type ?? ""
            }
          />
        ))}
      </div>
      <FileUploadButton
        authorizeRequest={assetUpdateFunction}
        permittedContentTypes={["image/jpeg", "image/png", "application/pdf"]}
        permittedExtensions={["jpg", "jpeg", "png", "pdf"]}
        maxFileSizeBytes={10 * 1024 * 1024} // 10MB,
        maxWidthOrHeight={2048}
        onSuccess={onAssetUpdate}
        buttonText="Add Name Documentation"
        uploadImage={false}
        isProcessing={isProcessing}
        disabled={nameOnDocumentAssets?.length >= 8}
        cropAllowed={false}
      />
      <p className="text-sm text-gray-600 mt-2">(Max 8 files - PDF, JPEG or PNG)</p>
      <p className="text-sm text-black-500 mt-2">Note: Files uploaded here cannot be deleted</p>
    </div>
    
  );
};